import { render, staticRenderFns } from "./AppCollapsableText.vue?vue&type=template&id=99fe2c6c&scoped=true&"
import script from "./AppCollapsableText.vue?vue&type=script&lang=js&"
export * from "./AppCollapsableText.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapsableText.vue?vue&type=style&index=0&id=99fe2c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fe2c6c",
  null
  
)

export default component.exports